import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import NodeTree from './NodeTree';

const ChatJourneyBuilder = ({
  isEnabled,
  nodes,
  selectedNode,
  setSelectedNode,
  expandedKeys,
  setExpandedKeys,
  pathNodes,
  setPathNodes,
  showDialog,
  setShowDialog,
  setDialogType,
  setQuestion,
  setResponse,
  updateNode,
  addChildNode,
  removeNode,
  findParent,
  menuRefs,
  toast,
  setNodes,
  currentNode,
  handleAddFirstNode,
  hasChanges,
  saveChatJourney,
  setShowInstructions
}) => {
  const [showInstructions, setLocalShowInstructions] = useState(true);

  // Check if user has seen the instructions before
  useEffect(() => {
    const hasSeenInstructions = localStorage.getItem('hasSeenChatJourneyInstructions') === 'true';
    setLocalShowInstructions(!hasSeenInstructions);
    setShowInstructions(!hasSeenInstructions);
  }, [setShowInstructions]);

  const handleGotItClick = () => {
    localStorage.setItem('hasSeenChatJourneyInstructions', 'true');
    setLocalShowInstructions(false);
    setShowInstructions(false);
  };

  return (
    <div className="chat-journey-container">
      {showInstructions && !isEnabled && (
        <div className="panel instruction-panel">
          <h3>🎯 Getting Started with Chat Journey</h3>
          <div className="instruction-content">
            <p>Welcome to the Chat Journey Builder! Here's how it works:</p>
            <ol>
              <li>Build your conversation flow by adding questions and responses</li>
              <li>Test your journey in the simulator panel</li>
              <li>Save drafts as you work</li>
              <li>Publish when you're ready to make it live</li>
            </ol>
            <Button
              label="Got it!"
              icon="pi pi-check"
              className="p-button-primary"
              onClick={handleGotItClick}
            />
          </div>
        </div>
      )}

      {isEnabled && (
        <div className="builder-container">
          <div className="builder-header">
            <h3>Journey builder</h3>
            <div className="builder-actions">
              {nodes.length === 0 ? (
                <Button
                  label="Add your first message"
                  icon="pi pi-plus"
                  onClick={handleAddFirstNode}
                  className="p-button-primary"
                />
              ) : (
                hasChanges && (
                  <Button
                    label="Save Draft"
                    icon="pi pi-file-edit"
                    onClick={() => saveChatJourney(true)}
                    className="p-button-sm p-button-text"
                    disabled={!hasChanges}
                  />
                )
              )}
            </div>
          </div>

          {nodes.length > 0 && (
            <NodeTree
              nodes={nodes}
              selectedNode={selectedNode}
              setSelectedNode={setSelectedNode}
              expandedKeys={expandedKeys}
              setExpandedKeys={setExpandedKeys}
              pathNodes={pathNodes}
              setPathNodes={setPathNodes}
              showDialog={showDialog}
              setShowDialog={setShowDialog}
              setDialogType={setDialogType}
              setQuestion={setQuestion}
              setResponse={setResponse}
              updateNode={updateNode}
              addChildNode={addChildNode}
              removeNode={removeNode}
              findParent={findParent}
              menuRefs={menuRefs}
              toast={toast}
              setNodes={setNodes}
              currentNode={currentNode}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ChatJourneyBuilder; 